import { render, staticRenderFns } from "./courseSpend.vue?vue&type=template&id=e5a6cbae&scoped=true"
import script from "./courseSpend.vue?vue&type=script&lang=js"
export * from "./courseSpend.vue?vue&type=script&lang=js"
import style0 from "./courseSpend.vue?vue&type=style&index=0&id=e5a6cbae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a6cbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a6cbae')) {
      api.createRecord('e5a6cbae', component.options)
    } else {
      api.reload('e5a6cbae', component.options)
    }
    module.hot.accept("./courseSpend.vue?vue&type=template&id=e5a6cbae&scoped=true", function () {
      api.rerender('e5a6cbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/courseSpend.vue"
export default component.exports